import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=353b12f6&scoped=true&"
import script from "./Unit.vue?vue&type=script&lang=js&"
export * from "./Unit.vue?vue&type=script&lang=js&"
import style0 from "./Unit.vue?vue&type=style&index=0&id=353b12f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b12f6",
  null
  
)

export default component.exports